function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, tooltipErrorMsg) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-bucket-pane': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((tooltipErrorMsg) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'always-show': true,
              'hide-arrow': true,
              type: `error`,
            }),
          }, [__vjadeSafeCode(tooltipErrorMsg)]));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-bucket-pane-title': true
          },
        }, [__vjadeSafeCode($attr(`header`))]));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-bucket-pane-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-bucket-pane-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-pane-field': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-bucket-pane-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Interval Size");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: `number`,
                  'validation-status': $helpers.getBucketSizeValidationStatus(),
                }),
                "on": {
                  input: $helpers.changeBucketSize,
                  keyup: $helpers.handleKeyUp,
                },
                "props": {
                  value: $helpers.getBucketSize(),
                },
                "hook": {
                  insert: $helpers.inputInserted
                },
                "class": {
                  'mp-bucket-pane-input': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-pane-field': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($helpers.canSelectBucketUnit()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    sections: JSON.stringify($helpers.getBucketUnits()),
                    size: `large`,
                    elref: `bucketUnitSelector`,
                  }),
                  "on": {
                    change: $helpers.changeBucketUnit
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-bucket-pane-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-pane-field': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-bucket-pane-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Minimum");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: `number`,
                  'validation-status': $helpers.getMinValidationStatus(),
                }),
                "on": {
                  input: $helpers.changeBucketMin,
                  keyup: $helpers.handleKeyUp,
                },
                "props": {
                  value: $helpers.getMin()
                },
                "class": {
                  'mp-bucket-pane-input': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-pane-field': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-bucket-pane-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Maximum");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: `number`,
                  'validation-status': $helpers.getMaxValidationStatus(),
                }),
                "on": {
                  input: $helpers.changeBucketMax,
                  keyup: $helpers.handleKeyUp,
                },
                "props": {
                  value: $helpers.getMax()
                },
                "class": {
                  'mp-bucket-pane-input': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(($attr(`reset-bucket`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `resetButton`,
            }),
            "on": {
              click: $helpers.resetInterval
            },
            "class": {
              'mp-bucket-pane-btn': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Reset");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'disabled': $helpers.submitDisabled(),
            'theme': 'primary',
            elref: `applyButton`,
          }),
          "on": {
            click: $helpers.applyBucketSelections
          },
          "class": {
            'mp-bucket-pane-btn': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Apply");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "tooltipErrorMsg" in locals ? locals.tooltipErrorMsg : typeof tooltipErrorMsg !== "undefined" ? tooltipErrorMsg : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;